import { render, staticRenderFns } from "./softwareList.vue?vue&type=template&id=157c3622&scoped=true&"
import script from "./softwareList.vue?vue&type=script&lang=js&"
export * from "./softwareList.vue?vue&type=script&lang=js&"
import style0 from "./softwareList.vue?vue&type=style&index=0&id=157c3622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157c3622",
  null
  
)

export default component.exports